import './Loader.scss';

const Loader = () => {
  return (
    <div className='loaderBox'>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Loader;
